import React from 'react'

const NotFound =() =>{
    return (
    <>
      <div style={{textAlign:'center', paddingTop:'10%'}}>
        <h2>404 page not found</h2>
        <br/>
        <p>We are sorry but the page you are looking for does not exist.</p>
      </div>
    </>
    
)
}
export default NotFound;